import React from "react";

import {
  Button,
  ButtonVariant
} from "@patternfly/react-core";

import useNavigation from "../hooks/useNavigation";

const SchoolNavigationMobile = () => {
  const {
    isMenuOpen,
    toggleMobileMenu,
  } = useNavigation();

  return (
    <Button
      variant={ButtonVariant.control}
      isHamburger
      isExpanded={isMenuOpen}
      isClicked={isMenuOpen}
      onClick={toggleMobileMenu}
      aria-label="Open navigation"
    />
  );
};

export default SchoolNavigationMobile;